export const LANGFUSE_ENVIRONMENTS = {
    test: {
        label: '测试',
        baseUrl: 'https://langfuse.dev.jdydevelop.com',
    },
    production: {
        label: '生产',
        baseUrl: 'https://langfuse.ops.jdydevelop.com',
    },
} as const;

export interface LangfuseSettings {
    baseUrl: string;
    publicKey: string;
    secretKey: string;
}

export type ToolCategory = 'frontend' | 'backend' | 'other';

export interface ToolMetric {
    name: string;
    category: ToolCategory;
    calls: number;
    failures: number;
}

export interface ToolTrendPoint {
    date: string;
    calls: number;
}

export interface ToolInsights {
    traceName: string;
    totalCalls: number;
    activeTools: number;
    failedCalls: number;
    averageLatencyMs: number | null;
    tools: ToolMetric[];
    trend: ToolTrendPoint[];
    refreshedAt: string;
}

export interface ToolInsightsRequest extends LangfuseSettings {
    fromTimestamp: string;
    toTimestamp: string;
}

export interface ParameterFailureMetric {
    name: string;
    category: ToolCategory;
    failures: number;
}

export interface ParameterFailureOccurrence {
    callKey: string;
    name: string;
    category: ToolCategory;
}

export type ParameterFailureTruncationReason = 'observation_limit' | 'response_size_limit' | null;

export type ParameterFailureBatchStopReason =
    | 'complete'
    | 'batch_limit'
    | 'time_limit'
    | 'observation_limit'
    | 'response_size_limit';

export interface ParameterFailureQueryLimits {
    maxObservations: number;
    maxBatchObservations: number;
    maxPageBytes: number;
    pageSize: number;
    queryBudgetMs: number;
}

export interface ParameterFailureBatch {
    traceName: string;
    occurrences: ParameterFailureOccurrence[];
    scannedObservations: number;
    availableObservations: number;
    complete: boolean;
    nextPage: number | null;
    stopReason: ParameterFailureBatchStopReason;
    limits: ParameterFailureQueryLimits;
    refreshedAt: string;
}

export interface ParameterFailureInsights {
    traceName: string;
    failures: ParameterFailureMetric[];
    totalParameterFailures: number;
    scannedObservations: number;
    availableObservations: number;
    complete: boolean;
    truncationReason: ParameterFailureTruncationReason;
    limits: ParameterFailureQueryLimits;
    refreshedAt: string;
}
